import { useEffect, useMemo, useState } from "react";

import SectionCard from "@buildpy/ui/section-card";
import { Input } from "@buildpy/ui/input";
import ConstructionNotice from "@/modules/print/construction-notice";
import PrintButton from "@/modules/print/print-button";
import { normalizeNoticeQrUrl } from "@buildpy/core/modules/tools/notice-qr";

const DEFAULTS = { address: "", startDate: "", endDate: "", hours: "09:00 ~ 18:00", work: "" };

// 로그인 없는 공사 안내문 — 시공사·QR 주소는 이 화면 상태로만 두고 서버에 보내지 않는다.
const NoticeTool = () => {
  const [name, setName] = useState("");
  const [tel, setTel] = useState("");
  const [qrText, setQrText] = useState("");
  const [qrSvg, setQrSvg] = useState<string | null>(null);
  const qr = useMemo(() => normalizeNoticeQrUrl(qrText), [qrText]);
  const qrUrl = qr.kind === "ok" ? qr.url : null;

  useEffect(() => {
    if (qrUrl === null) {
      setQrSvg(null);
      return;
    }
    let cancelled = false;
    import("qrcode")
      .then((QRCode) => QRCode.toString(qrUrl, { type: "svg", margin: 1, errorCorrectionLevel: "M" }))
      .then((svg) => {
        if (!cancelled) setQrSvg(svg);
      })
      .catch(() => {
        if (!cancelled) setQrSvg(null);
      });
    return () => {
      cancelled = true;
    };
  }, [qrUrl]);

  return (
    <div className="flex flex-col gap-4">
      <SectionCard className="print-hide mx-auto w-full max-w-[210mm] text-sm" data-testid="notice-tool" padding="sm">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <Input id="tool-contractor" label="시공사명" name="tool-contractor" value={name} onChange={(e) => setName(e.target.value)} />
          <Input
            id="tool-tel"
            inputMode="tel"
            label="연락처"
            name="tool-tel"
            value={tel}
            onChange={(e) => setTel(e.target.value)}
          />
          <div className="md:col-span-2">
            <Input
              errorMessage={qr.kind === "invalid" ? qr.reason : undefined}
              id="tool-qr"
              inputMode="url"
              label="QR 로 열 주소 (비우면 QR 없이 인쇄)"
              name="tool-qr"
              placeholder="https://"
              value={qrText}
              onChange={(e) => setQrText(e.target.value)}
            />
          </div>
        </div>
        <p className="mt-3 text-xs text-muted-foreground">
          buildpy(빌드파이)로 가입하면 이 QR 로 들어온 문의가 자동으로 기록됩니다.
        </p>
        <div className="mt-3 flex justify-end">
          <PrintButton label="안내문 인쇄" />
        </div>
      </SectionCard>
      <div className="print-root">
        <ConstructionNotice contractorName={name} contractorTel={tel} defaults={DEFAULTS} qrSvg={qrSvg} />
      </div>
    </div>
  );
};

export default NoticeTool;
